import { Start, Stop } from 'smg/buttons';
import * as quoterequests from 'smg/customer-api/quoterequests';
import { Session } from 'smg/customer-api/session';
import { ShowError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import * as html from 'smg/html';
import { GetReadableSize } from 'smg/lineitemtypesizes';
import * as models from 'smg/customer-api/models';
import { Uploads } from 'smg/customer-api/v2/uploads';
import { CleanNumber } from 'smg/number';
import { Phone } from 'smg/phone';
import * as uploadClaims from 'smg/upload-claims';
import * as uploads from 'smg/uploads';
import { GetFirstAndLast } from 'smg/users';
import { DollarFormat } from 'smg/util';
import * as sidebar from '../../free-quote/sidebar';
import * as store from '../../free-quote/store';
import { Relref } from '../../hugo';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
    readonly product: string;
}
declare const window: myWindow;

main();

function main() {
    store.Init();

    const settings = store.Get();
    if (!settings.getStarted || !settings.details || !settings.upload) {
        store.Redirect();
        return;
    }

    const $form = document.querySelector('#free-quote-form') as HTMLFormElement;
    const $fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;

    const $freeQuoteDetails = document.querySelectorAll<HTMLElement>('.free-quote-detail');
    const $qty = document.querySelector<HTMLElement>('#free-quote-qty');

    const $designContainer = document.querySelector('#free-quote-design-container') as HTMLElement;
    const $frontContainer = document.querySelector('#free-quote-design-front-container') as HTMLElement;
    const $frontUploadsContainer = document.querySelector('#free-quote-design-front-uploads-container') as HTMLElement;
    const $frontUploads = document.querySelector('#free-quote-basic-details-front-uploads') as HTMLElement;
    const $frontNotesContainer = document.querySelector('#free-quote-design-front-notes-container') as HTMLElement;
    const $frontNotes = document.querySelector('#free-quote-basic-details-front-notes') as HTMLElement;

    const $backContainer = document.querySelector('#free-quote-design-back-container') as HTMLElement;
    const $backUploadsContainer = document.querySelector('#free-quote-design-back-uploads-container') as HTMLElement;
    const $backUploads = document.querySelector('#free-quote-basic-details-back-uploads') as HTMLElement;
    const $backNotesContainer = document.querySelector('#free-quote-design-back-notes-container') as HTMLElement;
    const $backNotes = document.querySelector('#free-quote-basic-details-back-notes') as HTMLElement;

    const $inDepthContainer = document.querySelector('#free-quote-in-depth-container') as HTMLElement;

    const $name = document.querySelector('#free-quote-name') as HTMLInputElement;
    const $company = document.querySelector('#free-quote-company') as HTMLInputElement;
    const $email = document.querySelector('#free-quote-email') as HTMLInputElement;
    const $phone = document.querySelector('#free-quote-phone') as HTMLInputElement;

    const $preferredContactCall = document.querySelector('#free-quote-contact-call') as HTMLInputElement;
    const $preferredContactText = document.querySelector('#free-quote-contact-text') as HTMLInputElement;
    const $preferredContactEmail = document.querySelector('#free-quote-contact-email') as HTMLInputElement;

    const p = new Phone($phone);

    if (settings.inDepth) {
        const $back = document.querySelector('#back') as HTMLAnchorElement;
        if (window.location.href.includes('american-made')) {
            $back.href = Relref('/american-made-free-quote/in-depth');
        } else {
            $back.href = Relref('/free-quote/in-depth');
        }
    }

    const $color = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Color' && $detail.getAttribute('data-value') === settings.details?.color);
    $color?.classList.remove('d-none');

    const $size = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Size' && $detail.getAttribute('data-value') === settings.details?.size);
    $size?.classList.remove('d-none');
    if (settings.details?.size === 'custom') {
        const $sizeTitle = $size?.querySelector('.free-quote-option-value') as HTMLElement;
        $sizeTitle.textContent = `${$sizeTitle.textContent ?? ''}: ${GetReadableSize(settings.details.customWidth, settings.details.customHeight, '')}`;
    }

    const $type = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Type' && $detail.getAttribute('data-line-item-type-id') === settings.details?.lineItemTypeID);
    $type?.classList.remove('d-none');

    const $backing = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Backing' && $detail.getAttribute('data-value') === settings.details?.backing);
    $backing?.classList.remove('d-none');

    const $lanyardAttachment = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Attachment' && $detail.getAttribute('data-value') === settings.details?.attachment);
    $lanyardAttachment?.classList.remove('d-none');

    const quantity = (): number => settings.details?.qty === 'custom' ? settings.details.customQty || 0 : parseInt(CleanNumber(settings.details?.qty || '0'), 10);

    if ($qty) {
        $qty.textContent = Intl.NumberFormat().format(quantity());
    }

    if (settings.upload?.front?.uploadClaims) {
        uploadClaims.RegisterRecord(settings.upload.front.uploadClaims);
    }
    if (settings.upload?.back?.uploadClaims) {
        uploadClaims.RegisterRecord(settings.upload.back.uploadClaims);
    }

    if (settings.upload?.front?.uploadIDs.length) {
        $designContainer.classList.remove('d-none');
        $frontContainer.classList.remove('d-none');
        $frontUploadsContainer.classList.remove('d-none');

        void Uploads({
            q: `id:${settings.upload.front.uploadIDs.join(',')}`,
            data: 'id,name,mime,key',
        }).then(resp => {
            resp.results.forEach(u => {
                const $thumb = html.FromString(`
                <div class="uploader-thumbnail">
                    <a class="uploader-thumbnail-img-link" href="#" data-fancybox="free-quote-upload-front">
                        <div class="uploader-thumbnail-img-link-spinner-parent">
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <img class="uploader-thumbnail-img" src="" style="max-height:100px;max-width:100px" alt="" title="" crossorigin="crossorigin">
                    </a>
                    <div class="d-flex">
                        <div class="uploader-thumbnail-name flex-grow-1 text-truncate" style="max-width:100px"></div>
                    </div>
                </div>`).firstElementChild as HTMLElement;

                const $a = $thumb.querySelector('.uploader-thumbnail-img-link') as HTMLAnchorElement;
                const $img = $thumb.querySelector('.uploader-thumbnail-img') as HTMLImageElement;
                const $name = $thumb.querySelector('.uploader-thumbnail-name') as HTMLElement;

                const src = u.url();
                $a.href = src;
                $a.setAttribute('data-caption', u.name);

                void uploads.Load($img, src, u.name).then(success => {
                    if (!success) {
                        $thumb.classList.add('uploader-thumbnail--no-preview');
                    }
                });

                $name.innerText = u.name;
                $name.title = u.name;

                $frontUploads.appendChild($thumb);

                $thumb.classList.remove('uploader-thumbnail--loading');
                $thumb.querySelector('.uploader-thumbnail-img-link-spinner-parent')?.remove();
            });
        });
    }

    if (settings.upload?.front?.notes) {
        $designContainer.classList.remove('d-none');
        $frontContainer.classList.remove('d-none');
        $frontNotesContainer.classList.remove('d-none');
        $frontNotes.textContent = settings.upload.front.notes;
    }

    if (settings.upload?.back?.uploadIDs.length) {
        $designContainer.classList.remove('d-none');
        $backContainer.classList.remove('d-none');
        $backUploadsContainer.classList.remove('d-none');

        void Uploads({
            q: `id:${settings.upload.back.uploadIDs.join(',')}`,
            data: 'id,name,mime,key',
        }).then(resp => {
            resp.results.forEach(u => {
                const $thumb = html.FromString(`
                <div class="uploader-thumbnail">
                    <a class="uploader-thumbnail-img-link" href="#" data-fancybox="free-quote-upload-back">
                        <div class="uploader-thumbnail-img-link-spinner-parent">
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <img class="uploader-thumbnail-img" src="" style="max-height:100px;max-width:100px" alt="" title="" crossorigin="crossorigin">
                    </a>
                    <div class="d-flex">
                        <div class="uploader-thumbnail-name flex-grow-1 text-truncate" style="max-width:100px"></div>
                    </div>
                </div>`).firstElementChild as HTMLElement;

                const $a = $thumb.querySelector('.uploader-thumbnail-img-link') as HTMLAnchorElement;
                const $img = $thumb.querySelector('.uploader-thumbnail-img') as HTMLImageElement;
                const $name = $thumb.querySelector('.uploader-thumbnail-name') as HTMLElement;

                const src = u.url();
                $a.href = src;
                $a.setAttribute('data-caption', u.name);

                void uploads.Load($img, src, u.name).then(success => {
                    if (!success) {
                        $thumb.classList.add('uploader-thumbnail--no-preview');
                    }
                });

                $name.innerText = u.name;
                $name.title = u.name;

                $backUploads.appendChild($thumb);

                $thumb.classList.remove('uploader-thumbnail--loading');
                $thumb.querySelector('.uploader-thumbnail-img-link-spinner-parent')?.remove();
            });
        });
    }

    if (settings.upload?.back?.notes) {
        $designContainer.classList.remove('d-none');
        $backContainer.classList.remove('d-none');
        $backNotesContainer.classList.remove('d-none');
        $backNotes.textContent = settings.upload.back.notes;
    }

    if (settings.details.color === 'yes') {
        const $pinType = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Pin Type' && $detail.getAttribute('data-value') === settings.inDepth?.type);
        if ($pinType) {
            $pinType.classList.remove('d-none');
            $inDepthContainer.classList.remove('d-none');
        }
    }

    const $patchType = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Patch Type' && $detail.getAttribute('data-value') === settings.inDepth?.type);
    if ($patchType) {
        $patchType.classList.remove('d-none');
        $inDepthContainer.classList.remove('d-none');
    }

    const $lanyardType = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Lanyard Type' && $detail.getAttribute('data-value') === settings.inDepth?.type);
    if ($lanyardType) {
        $lanyardType.classList.remove('d-none');
        $inDepthContainer.classList.remove('d-none');
    }

    const $plating = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Metal Plating' && $detail.getAttribute('data-value') === settings.inDepth?.plating);
    if ($plating) {
        $plating.classList.remove('d-none');
        $inDepthContainer.classList.remove('d-none');
    }

    const $finish = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Metal Finish' && $detail.getAttribute('data-value') === settings.inDepth?.finish);
    if ($finish) {
        $finish.classList.remove('d-none');
        $inDepthContainer.classList.remove('d-none');
    }

    const $edge = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Edge' && $detail.getAttribute('data-value') === settings.inDepth?.edge);
    if ($edge) {
        $edge.classList.remove('d-none');
        $inDepthContainer.classList.remove('d-none');
    }

    const $attachment = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Attachment' && $detail.getAttribute('data-value') === settings.inDepth?.attachment);
    if ($attachment) {
        $attachment.classList.remove('d-none');
        $inDepthContainer.classList.remove('d-none');
    }

    const $accessory = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Accessory' && $detail.getAttribute('data-value') === settings.inDepth?.accessory);
    if ($accessory) {
        $accessory.classList.remove('d-none');
        $inDepthContainer.classList.remove('d-none');
    }

    const $feature = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Feature' && $detail.getAttribute('data-value') === settings.inDepth?.feature);
    if ($feature) {
        $feature.classList.remove('d-none');
        $inDepthContainer.classList.remove('d-none');
    }

    const $packaging = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Packaging' && $detail.getAttribute('data-value') === settings.inDepth?.packaging);
    if ($packaging) {
        $packaging.classList.remove('d-none');
        $inDepthContainer.classList.remove('d-none');
    }

    const $upgrade = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Upgrade' && $detail.getAttribute('data-value') === settings.inDepth?.upgrade);
    if ($upgrade) {
        $upgrade.classList.remove('d-none');
        $inDepthContainer.classList.remove('d-none');
    }

    const $location = Array.from($freeQuoteDetails).find($detail => $detail.getAttribute('data-name') === 'Location Preference' && $detail.getAttribute('data-value') === settings.inDepth?.location);
    if ($location) {
        $location.classList.remove('d-none');
        $inDepthContainer.classList.remove('d-none');
    }

    $name.value = settings.getStarted?.name || '';
    $email.value = settings.getStarted?.email || '';
    void p.ready().then(() =>
        p.iti.setNumber(settings.getStarted?.phone || ''));

    sidebar.$sidebarQty.textContent = Intl.NumberFormat().format(quantity());
    sidebar.$sidebarUnitPrice.textContent = DollarFormat(CleanNumber(settings.inDepth?.unitPrice || settings.details?.unitPrice || ''));
    sidebar.$sidebarMoldFee.textContent = DollarFormat(CleanNumber(settings.inDepth?.moldFee || settings.details?.moldFee || ''));
    sidebar.$sidebarTotal.textContent = DollarFormat(CleanNumber(settings.inDepth?.total || settings.details?.total || ''));

    if (settings.inDepth) {
        sidebar.SetPlating(settings.inDepth.plating);
        sidebar.SetUpgrade(settings.inDepth.upgrade, settings.details.color);
    } else {
        if (settings.details.type === 'Made in USA - Simulated Enamel Coin') {
            sidebar.SetPlating('Domestic Gold');
        } else {
            sidebar.SetPlating('');
        }
    }

    $form.noValidate = true;
    $form.addEventListener('submit', async e => {
        e.preventDefault();

        if (!ReportValidity($form)) {
            return;
        }

        Start(sidebar.$submit);
        $fieldset.disabled = true;

        const children: models.QuoteRequestCreateChild[] = [];
        if (settings.inDepth?.plating) {
            children.push(new models.QuoteRequestCreateChild({
                child: 'Plating',
                option: settings.inDepth.plating,
            }));
        }
        if (settings.inDepth?.finish) {
            children.push(new models.QuoteRequestCreateChild({
                child: 'Finish',
                option: settings.inDepth.finish,
            }));
        }
        if (settings.inDepth?.edge) {
            children.push(new models.QuoteRequestCreateChild({
                child: 'Edge',
                option: settings.inDepth.edge,
            }));
        }
        if (settings.inDepth?.attachment) {
            children.push(new models.QuoteRequestCreateChild({
                child: 'Attachment',
                option: settings.inDepth.attachment,
            }));
        }
        if (settings.inDepth?.packaging) {
            children.push(new models.QuoteRequestCreateChild({
                child: 'Packaging',
                option: settings.inDepth.packaging,
            }));
        }
        if (settings.details?.attachment) {
            children.push(new models.QuoteRequestCreateChild({
                child: 'Attachment',
                option: settings.details.attachment,
            }));
        }
        if (settings.inDepth?.accessory) {
            children.push(new models.QuoteRequestCreateChild({
                child: 'Accessory',
                option: settings.inDepth.accessory,
            }));
        }
        if (settings.details?.backing) {
            children.push(new models.QuoteRequestCreateChild({
                child: 'Backing',
                option: settings.details.backing,
            }));
        }

        const extras: models.QuoteRequestCreateExtra[] = [];
        extras.push(new models.QuoteRequestCreateExtra({
            name: 'Budget',
            value: settings.getStarted?.budgetDesc,
        }));

        let preferredFormOfContact = '';
        if ($preferredContactCall.checked) {
            preferredFormOfContact = 'Call';
        } else if ($preferredContactText.checked) {
            preferredFormOfContact = 'Text';
        } else if ($preferredContactEmail.checked) {
            preferredFormOfContact = 'Email';
        }
        extras.push(new models.QuoteRequestCreateExtra({
            name: 'Preferred form of contact',
            value: preferredFormOfContact,
        }));
        if (settings.inDepth?.feature && settings.inDepth?.feature !== 'None') {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Feature',
                value: settings.inDepth.feature,
            }));
        }
        if (settings.inDepth?.upgrade && settings.inDepth?.upgrade !== 'None') {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Upgrade',
                value: settings.inDepth.upgrade,
            }));
        }
        if (settings.inDepth?.location) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Manufacturing Location Preference',
                value: settings.inDepth.location,
            }));
        }
        if (settings.details?.shape) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Shape',
                value: settings.details.shape === 'Custom Shape' && settings.details.customShape ?
                    settings.details.customShape :
                    settings.details.shape,
            }));
        }

        let notes = '';
        if (window.product === 'Challenge Coin') {
            if (settings.upload?.front?.notes) {
                extras.push(new models.QuoteRequestCreateExtra({
                    name: 'Front',
                    value: settings.upload.front.notes,
                }));
            }

            if (settings.upload?.back?.notes) {
                extras.push(new models.QuoteRequestCreateExtra({
                    name: 'Back',
                    value: settings.upload.back.notes,
                }));
            }
        } else {
            notes = settings.upload?.front?.notes || '';
        }

        const size = store.Size();
        let width = store.Width();
        let height = store.Height();

        if (size) {
            width = 0;
            height = 0;
        }

        const uploadIDs = [];
        if (settings.upload?.front?.uploadIDs.length) {
            uploadIDs.push(...settings.upload.front.uploadIDs);
        }
        if (settings.upload?.back?.uploadIDs.length) {
            uploadIDs.push(...settings.upload.back.uploadIDs);
        }

        quoterequests.NewQuoteRequest({
            email: $email.value,
            company: $company.value,
            name: $name.value,
            phone: await p.format(),
            dateNeeded: settings.getStarted?.eventDate,
            form: 'main',
            lineItem: window.product,
            quantity: store.Quantity(),
            size,
            width,
            height,
            type: store.Type().name,
            uploadIDs,
            sms: true,
            notes,
            children,
            extras,
        }).then(async quoteRequest => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            const { firstName, lastName } = GetFirstAndLast(String($name.value));
            dataLayer.push({
                'event': 'hs-module-quote-form-success',
                'userData': {
                    'email': sess?.user.emailAddress.email || $email.value,
                    'phone': sess?.user.phoneNumber.phone || await p.format(),
                    'firstName': sess?.user.firstName || firstName,
                    'lastName': sess?.user.lastName || lastName,
                },
                'transactionId': quoteRequest.id,
                'total': quoteRequest.quotes?.[0].cachedTotal,
            });
            store.Clear();
            window.location.href = `${Relref('/free-quote/thank-you')}?id=${quoteRequest.quotes?.[0].key ?? ''}${settings.inDepthEnabled ? '&inDepth=true' : ''}`;
        }).catch(err => {
            ShowError(err);

            Stop(sidebar.$submit);
            $fieldset.disabled = false;
        });
    });

    const $spinner = document.querySelector('#free-quote-spinner-parent') as HTMLElement;
    const $content = document.querySelector('#free-quote-content') as HTMLElement;
    $spinner.remove();
    $content.classList.remove('d-none');
}
